import { HttpMethod, PaginatedResponse, Type } from "@/Utils/request/types";

import {
  MVPBillingConfiguration,
  MVPBillingConfigurationWrite,
  MVPPriceList,
  MVPPriceListWrite,
} from "./billing";

export default {
  listConfigurations: {
    path: "/api/v1/facility/{facilityId}/billing/configuration/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPBillingConfiguration>>(),
  },
  createConfiguration: {
    path: "/api/v1/facility/{facilityId}/billing/configuration/",
    method: HttpMethod.POST,
    TRes: Type<MVPBillingConfiguration>(),
    TBody: Type<MVPBillingConfigurationWrite>(),
  },
  updateConfiguration: {
    path: "/api/v1/facility/{facilityId}/billing/configuration/{configurationId}/",
    method: HttpMethod.PUT,
    TRes: Type<MVPBillingConfiguration>(),
    TBody: Type<MVPBillingConfigurationWrite>(),
  },
  listPriceLists: {
    path: "/api/v1/facility/{facilityId}/billing/price_lists/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPPriceList>>(),
  },
  createPriceList: {
    path: "/api/v1/facility/{facilityId}/billing/price_lists/",
    method: HttpMethod.POST,
    TRes: Type<MVPPriceList>(),
    TBody: Type<MVPPriceListWrite>(),
  },
} as const;
